import { writable } from "svelte/store";

export const DateFormatType = {
  YMD: "YMD",
  MDY: "MDY",
  DMY: "DMY",
};

export const mapBackendValueToFormatType = (value) => {
  switch (parseInt(value, 10)) {
    case 1:
      return DateFormatType.MDY;
    case 2:
      return DateFormatType.DMY;
    case 0:
    default:
      return DateFormatType.YMD;
  }
};

export const activeDateFormat = writable(DateFormatType.YMD);

export const dayjsFormats = {
  [DateFormatType.YMD]: {
    date: "YYYY/MM/DD",
    dateTime: "YYYY/MM/DD HH:mm:ss",
  },
  [DateFormatType.MDY]: {
    date: "MM/DD/YYYY",
    dateTime: "MM/DD/YYYY HH:mm:ss",
  },
  [DateFormatType.DMY]: {
    date: "DD/MM/YYYY",
    dateTime: "DD/MM/YYYY HH:mm:ss",
  },
};
